import { Spinner, Wrapper } from "./styled";

const Loader = () => (
  <Wrapper>
    <Spinner />
  </Wrapper>
);

export default Loader;
